import { useState, useEffect } from "react";
import Footer from "../../Components/Footer";
import API_URL from "../../const";
import Header from "../../Components/HeaderPublic";
import Cards from "./components/Cards";
import ToastInfo from "../../Components/Toast/ToastInfo";
import Spinner from "../../Components/Spinner/Spinner";
import FooterTransparent from "../../Components/footerTransparente";
import DetailPage from "./components/DetailPage";

// Estilo CSS para forzar full width en el footer
const fullWidthStyle = {
  width: "100vw",
  position: "relative",
  left: "50%",
  right: "50%",
  marginLeft: "-50vw",
  marginRight: "-50vw",
  overflowX: "hidden",
};

export default function CatalogoLogin() {
  const [IsOpenSpinner, setIsOpenSpinner] = useState(false);
  const [showToastInfo, setShowToastInfo] = useState(false);
  const [error, setError] = useState("");
  const [empresaData, setEmpresaData] = useState(null);
  const [showCards, setShowCards] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    window.scrollTo(0, 0);
    // El PageView se dispara de forma deduplicada desde usePageTracking (hook global).
  }, []);

  const Buscar = (uuid) => {
    setIsOpenSpinner(true);
    fetch(`${API_URL}getEmpresaDetalles.php?uuid=${uuid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.text())
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const jsonResponse =
          startIndex !== -1 ? text.substring(startIndex) : text;

        try {
          const responseData = JSON.parse(jsonResponse);
          setEmpresaData(responseData);
          setIsOpenSpinner(false);
        } catch (error) {
          console.error("Error al analizar JSON:", error);
          setError("Error de formato en la respuesta del servidor");
          setShowToastInfo(true);
          setIsOpenSpinner(false);
          setTimeout(() => setShowToastInfo(false), 3000);
        }
      })
      .catch((error) => {
        console.error("Error del servidor:", error);
        setError(error.message || "Error desconocido");
        setShowToastInfo(true);
        setIsOpenSpinner(false);
        setTimeout(() => setShowToastInfo(false), 3000);
      });
  };

  useEffect(() => {
    if (empresaData) {
      setShowCards(false);
    }
  }, [empresaData]);

  const idRol_fk = localStorage.getItem("idRol_fk");
  const isAuthorized = idRol_fk === "1" || idRol_fk === "2";

  return (
    <div className="absolute left-0 right-0 h-screen justify-between mb-16 bg-white">
      <Spinner isOpen={IsOpenSpinner}></Spinner>
      <Header />
      <ToastInfo
        isOpen={showToastInfo}
        title="Error"
        text={error || "Empresa no encontrada"}
      />
      <section className="bg-white">
        <div className="container px-6 py-12 mt-5 mx-auto">
          {showCards && (
            <Cards isAuthorized={isAuthorized} Buscar={Buscar} />
          )}
          {empresaData && <DetailPage empresaData={empresaData} />}
        </div>
      </section>

      <div style={fullWidthStyle} className="-mb-8">
        {empresaData ? <FooterTransparent /> : <Footer />}
      </div>
    </div>
  );
}
